/**
 * Emergency.js
 * This file handles the emergency popup.
 */

const emergencyLinks = document.querySelectorAll("a[href='#emergency'], .emergency-open");
const emergencyPopup = document.querySelector('.emergency');
const emergencyPopupBackdrop = document.querySelector('.emergency-backdrop');
const emergencyPopupCloseButton = document.querySelector('.emergency__btn-close');
const emergencyHash = '#emergency';

if (emergencyLinks && emergencyPopup && emergencyPopupBackdrop) {
  // Activate Emergency Popup
  emergencyLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      emergencyPopup.classList.add("emergency--active");
      emergencyPopupBackdrop.classList.add("emergency-backdrop--active");
    });
  });


  // Show emergency popup if window has hash url "#emergency"
  if (window.location.hash == '#emergency' && emergencyPopup) {
    emergencyPopup.classList.add('emergency--active');
    emergencyPopupBackdrop.classList.add('emergency-backdrop--active');
  }

  // When escape key is clicked hide the popup
  document.onkeyup = (e) => {
    if (e.key === "Escape" && emergencyPopup.classList.contains('emergency--active')) {
      closeEmergencyPopup();
    }
  };

  // When clicking on the backdrop hide the popup
  emergencyPopupBackdrop.addEventListener('click', closeEmergencyPopup);
  emergencyPopupCloseButton.addEventListener('click', closeEmergencyPopup);

}

function closeEmergencyPopup() {
  emergencyPopup.classList.remove('emergency--active');
  emergencyPopupBackdrop.classList.remove('emergency-backdrop--active');
}
